import { render, staticRenderFns } from "./status-form-output.vue?vue&type=template&id=8e38fb10&scoped=true&"
import script from "./status-form-output.vue?vue&type=script&lang=js&"
export * from "./status-form-output.vue?vue&type=script&lang=js&"
import style0 from "./status-form-output.vue?vue&type=style&index=0&id=8e38fb10&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e38fb10",
  null
  
)

export default component.exports